import React, { useState } from "react";
import { MDBDataTable } from "mdbreact";
import EntriesSelector from "../tableServerPagination/entriesSelector";
import PaginationButtons from "../tableServerPagination/paginationButtons";
//SweetAlert
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";
//i18n
import { withNamespaces } from "react-i18next";

// P01021-139: paginación server-side de verdad — antes MDBDataTable recibía la tabla entera
// filtrada en cliente y paginaba solo visualmente (`paging={true}`). Ahora cada tarjeta del
// Dashboard trae únicamente la página que toca, con paging={false} para que MDBDataTable
// solo la pinte, y EntriesSelector/PaginationButtons son los que piden la siguiente página
// al servidor (mismo patrón ya usado en TaskList.js para /tasks).
const DashboardList = function (props) {
  const [size, setSize] = useState(10);
  const [page, setPage] = useState(1);

  return (
    <React.Fragment>
      <EntriesSelector
        label={props.t("Show tasks")}
        size={size}
        setSize={setSize}
        setPage={setPage}
        getEntries={props.getEntries}
      />
      <MDBDataTable
        responsive
        striped
        bordered
        data={props.taskslist}
        info={false}
        paginationLabel={[props.t("Previous"), props.t("Next")]}
        entriesLabel={props.t("Show tasks")}
        noRecordsFoundLabel={props.t("No matching records found")}
        searchLabel={props.t("Search")}
        paging={false}
      />
      <PaginationButtons
        size={size}
        page={page}
        setPage={setPage}
        totalPages={props.totalPages}
        getEntries={props.getEntries}
        nextBtnLabel={props.t("Next")}
        prevBtnLabel={props.t("Previous")}
        t={props.t}
      />
    </React.Fragment>
  );
};

export default withNamespaces()(DashboardList);
